export const SERVICE = 'OPERATOR'
